import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "school-tuition" }
const _hoisted_2 = { class: "school-info" }
const _hoisted_3 = { class: "tuition-costs" }
const _hoisted_4 = { class: "cost" }
const _hoisted_5 = { class: "additional-funding" }
const _hoisted_6 = { class: "funding-field" }
const _hoisted_7 = { class: "funding-field" }
const _hoisted_8 = { class: "hint" }
const _hoisted_9 = { class: "funding-field" }
const _hoisted_10 = { class: "difference" }
const _hoisted_11 = { class: "remaining-balance" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_base_form_field = _resolveComponent("base-form-field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calculator", { loc: _ctx.productTypeId === _ctx.ProductIds.LOC, pel: _ctx.productTypeId === _ctx.ProductIds.PEL }])
  }, [
    _createElementVNode("a", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, [
      _createVNode(_component_icon, { icon: "close" })
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Estimated Cost of Attendance", -1)),
    _cache[14] || (_cache[14] = _createElementVNode("p", null, " The cost of attendance listed is an estimated amount associated with these types of programs. Actual costs may vary based on the specific program, remaining years of study, and location. Please consult your school's admissions or financial aid office for your official cost of attendance. ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.info?.school?.schoolName ? _ctx.info?.school?.schoolName : _ctx.school), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.term ? _ctx.term : "Not Yet Selected"), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            class: _normalizeClass({ active: _ctx.tuitionType === 'in-state' }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tuitionType = 'in-state'))
          }, " In State ", 2),
          _cache[7] || (_cache[7] = _createTextVNode(" | ", -1)),
          _createElementVNode("span", {
            class: _normalizeClass({ active: _ctx.tuitionType === 'out-of-state' }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tuitionType = 'out-of-state'))
          }, " Out of State ", 2)
        ]),
        _createElementVNode("p", _hoisted_4, "$" + _toDisplayString(isNaN(_ctx.formatNumber(_ctx.tuition)) ? _ctx.formatNumber(_ctx.tuition) : ""), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[11] || (_cache[11] = _createElementVNode("h3", null, "How Much Funding Do You Already Have?", -1)),
      _createElementVNode("div", _hoisted_6, [
        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Scholarships & Grants", -1)),
        _createVNode(_component_base_form_field, {
          modelValue: _ctx.funding.scholarshipsAndGrants,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.funding.scholarshipsAndGrants) = $event)),
          schema: _ctx.schema.scholarshipsAndGrants
        }, null, 8, ["modelValue", "schema"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, [
          _cache[9] || (_cache[9] = _createTextVNode(" Federal & Private Loans ", -1)),
          _createElementVNode("span", _hoisted_8, " Not including this " + _toDisplayString(_ctx.productTypeId === _ctx.ProductIds.LOC ? "line" : "loan"), 1)
        ]),
        _createVNode(_component_base_form_field, {
          modelValue: _ctx.funding.loans,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.funding.loans) = $event)),
          schema: _ctx.schema.loans
        }, null, 8, ["modelValue", "schema"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[10] || (_cache[10] = _createElementVNode("label", null, [
          _createTextVNode(" Savings "),
          _createElementVNode("span", { class: "hint" }, " Savings or money from family & friends that you plan to use ")
        ], -1)),
        _createVNode(_component_base_form_field, {
          modelValue: _ctx.funding.savings,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.funding.savings) = $event)),
          schema: _ctx.schema.savings
        }, null, 8, ["modelValue", "schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Difference", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, "$" + _toDisplayString(isNaN(_ctx.formatNumber(_ctx.difference)) ? _ctx.formatNumber(_ctx.difference) : ""), 1),
        _createElementVNode("a", {
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.useThisAmount && _ctx.useThisAmount(...args)))
        }, "Use this amount")
      ])
    ])
  ], 2))
}